import React, { useContext } from 'react'
import './index.scss'
import InputText from '@Components/Fields/InputText'
import Dropdown from '@Components/Selectors/Dropdown'
import { observer } from 'mobx-react'
import { PHONE_NUMBER_FORM } from '@Const/forms-constants'
import { StoresContext } from '@App/contexts'
import { OptionModel } from '@Entities/lib'

interface IProps {
    phoneCountryCode?: number | null
    phoneAreaCode?: string | null
    phoneNumber?: string
    phoneCountryCodeError?: string
    phoneAreaCodeError?: string
    phoneNumberError?: string
    phoneCountryCodeRequired?: boolean
    phoneAreaCodeRequired?: boolean
    phoneNumberRequired?: boolean
    onChange: (value: string | number | null, id: string) => void
}

const PhoneNumberComponent = observer((props: IProps) => {
    const { libStore } = useContext(StoresContext)
    const countryPhoneOptions: OptionModel[] = libStore.phoneCountryCodes
    const getValue = (value: string | number, id: string) => {
        switch (id) {
            case PHONE_NUMBER_FORM.phoneCountryCode.id:
                props.onChange(value, PHONE_NUMBER_FORM.phoneCountryCode.id)
                break
            case PHONE_NUMBER_FORM.phoneAreaCode.id:
                props.onChange(value, PHONE_NUMBER_FORM.phoneAreaCode.id)
                break
            case PHONE_NUMBER_FORM.phoneNumber.id:
                props.onChange(value, PHONE_NUMBER_FORM.phoneNumber.id)
                break
            default:
                break
        }
    }

    return (
        <div className="phone-number-component">
            <p className="small main-label">Phone Number</p>
            <div className="inputs-block">
                <div className="country">
                    <Dropdown
                        options={countryPhoneOptions}
                        id={PHONE_NUMBER_FORM.phoneCountryCode.id}
                        selectedValue={countryPhoneOptions.find(
                            (option) => Number(option.value) === props.phoneCountryCode
                        )}
                        placeholder="Country"
                        mainColor
                        isPhoneCodeType
                        isBorder
                        onSelect={(data) => getValue(Number(data.value), PHONE_NUMBER_FORM.phoneCountryCode.id)}
                        isSearchable
                        isNumberType
                        errorMessage={props.phoneCountryCodeError}
                        assistiveText={props.phoneCountryCodeRequired ? 'Country Required' : 'Country'}
                    />
                </div>
                <div className="area">
                    <InputText
                        mainColor
                        id={PHONE_NUMBER_FORM.phoneAreaCode.id}
                        label=""
                        assistiveText={props.phoneAreaCodeRequired ? 'Area Required' : 'Area'}
                        onChange={getValue}
                        value={props.phoneAreaCode}
                        errorMessage={props.phoneAreaCodeError}
                    />
                </div>
                <div className="number">
                    <InputText
                        mainColor
                        id={PHONE_NUMBER_FORM.phoneNumber.id}
                        label=""
                        onChange={getValue}
                        value={props.phoneNumber}
                        errorMessage={props.phoneNumberError}
                        assistiveText={props.phoneNumberRequired ? 'Required Number' : 'Number'}
                    />
                </div>
            </div>
        </div>
    )
})

export default PhoneNumberComponent
